import { Component, OnInit, Input } from '@angular/core';
import { AdditionalField } from '../models/additional-field.model';
import { HelperService } from '../services/helper.service';
import { INVALIDDATE } from 'src/app/features/guided-order/samples/constants/sample-constants';

@Component({
    selector: 'app-additional-fields',
    templateUrl: './additional-fields.component.html',
    styleUrls: ['./additional-fields.component.scss']
})
export class AdditionalFieldsComponent implements OnInit {
    @Input() additionalFields: AdditionalField[];
    dateFormat: string;
    toString = toString;
    constructor(private helperService: HelperService) { }

    ngOnInit(): void {
        this.dateFormat = this.helperService.getDateOriginalFormat(window.navigator.language);

    }

    isValidDate(date: string): boolean {
        if (!date) { return false; }
        return new Date(date).toString() !== INVALIDDATE;
    }
}
